module.exports = {"110115001":"兴丰街道","110115002":"林校路街道","110115003":"清源街道","110115004":"亦庄地区","110115005":"黄村地区","110115006":"旧宫地区","110115007":"西红门地区","110115008":"瀛海地区","110115009":"观音寺街道","110115010":"天宫院街道","110115011":"高米店街道","110115012":"荣华街道","110115013":"博兴街道","110115103":"青云店镇","110115104":"采育镇","110115105":"安定镇","110115106":"礼贤镇","110115107":"榆垡镇","110115108":"庞各庄镇","110115109":"北臧村镇","110115110":"魏善庄镇","110115111":"长子营镇","110115403":"北京经济技术开发区","110115404":"中关村国家自主创新示范区大兴生物医药产业基地","110115405":"国家新媒体产业基地"}


//////////////////
// WEBPACK FOOTER
// ./src/town/110115.json
// module id = 33
// module chunks = 0